import { PhoneType } from "../../types";
import { IndustryDto, PostAddress } from "../../api/commercial/generated-types";

export enum LegalForm {
  SOLE_PROPRIETORSHIP = "SOLE_PROPRIETORSHIP",

  COLLECTIVE_PROPRIETORSHIP = "COLLECTIVE_PROPRIETORSHIP",

  LIMITED_COMPANY = "LIMITED_COMPANY",

  LIMITED_LIABILITY_COMPANY = "LIMITED_LIABILITY_COMPANY",

  COLLECTIVE = "COLLECTIVE",

  ASSOCIATION = "ASSOCIATION",

  FOUNDATION = "FOUNDATION",

  SPECIAL_LEGAL_FORM = "SPECIAL_LEGAL_FORM",

  SWISS_BRANCH = "SWISS_BRANCH",

  LIMITED_PARTNERSHIP = "LIMITED_PARTNERSHIP",

  ASSOCIATION_LIMITED_BY_SHARES = "ASSOCIATION_LIMITED_BY_SHARES",

  INDIVISION = "INDIVISION",

  PUBLIC_LAW_INSTITUTION = "PUBLIC_LAW_INSTITUTION",

  NON_COMMERCIAL_POWER_OF_ATTORNEY = "NON_COMMERCIAL_POWER_OF_ATTORNEY",

  FOREIGN_BRANCH = "FOREIGN_BRANCH",
}

export interface CompanyModel {
  ehraid?: string;
  uid?: string;
  chid?: string;
  isCompanyManuallyEntered: boolean;
  name: string;
  fullStreet: string;
  address: PostAddress;
  phone: PhoneType | string;
  legalForm: LegalForm;
  industryNogaCode?: string;
  industryBranchCode: string;
  industrySubBranchCode?: string;
  foundationDate: string;
  capitalNom?: number;
  enteredInTradeRegistryDate?: string;
}

export interface HomeModel {
  industries?: IndustryDto[];
  basicAccountApplicationRef?: string;
  isCompanyManuallyEntered: boolean;
  manuallyEnteredCompany: CompanyModel;
  selectedCompany: CompanyModel | undefined;
}
